import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Raiz do Assistente IA — não tem tela própria. Redireciona para o dashboard de uso,
 * para que `/tutor-ai` continue sendo um endereço válido sem que a sidebar acenda
 * dois itens ao mesmo tempo (o item ativo é resolvido por prefixo de rota).
 */
export const Route = createFileRoute('/_authenticated/tutor-ai/')({
  beforeLoad: () => {
    throw redirect({ to: '/tutor-ai/usage' });
  },
});
